import { gql } from '@apollo/client'

export const GET_ORDERS_BY_ORGANISATION = gql`
  query getOrdersByOrganisation($organisationName: String!) {
    getOrdersByOrganisation(organisationName: $organisationName) {
      orderId
      userId
      eventId
      quantity
      paid
      paymentProcessor
      paymentStatus
      paymentLastUpdated
      tickets {
        title
        email
        fullName
        discountCode
      }
    }
  }
`
